import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { connect } from 'react-redux';
import { addCommas } from "../../../utils/utils";
import Typography from "material-ui/Typography";
import ItemDetailsComponent from "../../OrderList/parts/ItemDetails"; // 外部ルートのディレクトリのインポートのため、Component末尾に付与している
import DownloadButtonsComponent from "../../OrderList/parts/DownloadButtons"; // 外部ルートのディレクトリのインポートのため、Component末尾に付与している

const styles = () => ({
  root: {
    display: "flex",
    justifyContent: 'space-between',
    padding: "24px 28px",
    boxSizing: "border-box",
    marginBottom: "22px",
    color: "#1A65FF",
    background: "#F2F6FF",
  },

  left: {
    marginRight: 20,
  },

  right: {
    textAlign: 'end',
    margin: 'auto 0',
  },
});

class ItemDetails extends React.Component {
  render() {
    const { classes, isLoading, item } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.left}>
          <Typography variant="body1" style={{ color: '#195AFF', marginBottom: 5 }}>
            {(() => {
              if (isLoading) {
                return "No.";
              } else if (item && item.letter_order) {
                return "レター注文No." + item.letter_order.id;
              } else if (item && item.follow_call_order) {
                return "フォローコール注文No." + item.follow_call_order.id;
              } else {
                return "No.";
              }
            })()}
          </Typography>
          <Typography style={{ fontSize: 30, color: "#1F73FF" }}>
            {(() => {
              if (isLoading) {
                return "- ";
              } else if (item && item.letter_order) {
                return addCommas(item.letter_order.order_addresses_count);
              } else if (item && item.follow_call_order) {
                return addCommas(item.follow_call_order.order_addresses_count);
              } else {
                return "- ";
              }
            })()}通
          </Typography>
          {!isLoading && item && (
            <ItemDetailsComponent
              item={item}
            />
          )}
        </div>
        <div className={classes.right}>
          {!isLoading && item && item.letter_order && (
            // DLボタンなどを表示
            <DownloadButtonsComponent
              item={item.letter_order}
              isAnchorTag={false}
            />
          )}
        </div>
      </div>
    )
  }
}

ItemDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  isLoading: PropTypes.bool,
};


const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ItemDetails));



// WEBPACK FOOTER //
// ./src/components/OrderDetail/rows/ItemDetails.jsx